const FINALS_OPTIONS = [
    {label: '1/16 Final', value: '1/16'},
    {label: '1/8 Final', value: '1/8'},
    {label: '1/4 Final', value: '1/4'},
    {label: '1/2 Final', value: '1/2'},
    {label: 'Final', value: 'final'},
    {label: '1/32 Final', value: '1/32'},
    {label: '1/64 Final', value: '1/64'}
]

const GROUPS_OPTIONS = [
    {label: 'Group A', value: 'a'},
    {label: 'Group B', value: 'b'},
    {label: 'Group C', value: 'c'},
    {label: 'Group D', value: 'd'},
    {label: 'Group E', value: 'e'},
    {label: 'Group F', value: 'f'},
    {label: 'Group G', value: 'g'}
]

export {FINALS_OPTIONS, GROUPS_OPTIONS}